var _g, _g2, _circle, _circle2, _circle3, _g3, _path, _path2, _g4, _g5, _g6, _g7, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 430,
    viewBox: "0 0 401 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_59_619)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 399,
    height: 267,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4032 55H32.5968C30.058 55 28 57.0664 28 59.6154V62.3846C28 64.9336 30.058 67 32.5968 67H80.4032C82.942 67 85 64.9336 85 62.3846V59.6154C85 57.0664 82.942 55 80.4032 55Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.469 55H97.5312C95.0287 55 93 57.0664 93 59.6154V62.3846C93 64.9336 95.0287 67 97.5312 67H117.469C119.971 67 122 64.9336 122 62.3846V59.6154C122 57.0664 119.971 55 117.469 55Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.556 55H134.444C131.99 55 130 57.0664 130 59.6154V62.3846C130 64.9336 131.99 67 134.444 67H141.556C144.01 67 146 64.9336 146 62.3846V59.6154C146 57.0664 144.01 55 141.556 55Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3846 76H32.6154C30.0664 76 28 78.0664 28 80.6154V83.3846C28 85.9336 30.0664 88 32.6154 88H35.3846C37.9336 88 40 85.9336 40 83.3846V80.6154C40 78.0664 37.9336 76 35.3846 76Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3279 76H51.6721C49.0918 76 47 78.0664 47 80.6154V83.3846C47 85.9336 49.0918 88 51.6721 88H99.3279C101.908 88 104 85.9336 104 83.3846V80.6154C104 78.0664 101.908 76 99.3279 76Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.306 76H115.694C113.102 76 111 78.0664 111 80.6154V83.3846C111 85.9336 113.102 88 115.694 88H152.306C154.898 88 157 85.9336 157 83.3846V80.6154C157 78.0664 154.898 76 152.306 76Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3676 98H32.6324C30.074 98 28 100.066 28 102.615V105.385C28 107.934 30.074 110 32.6324 110H86.3676C88.926 110 91 107.934 91 105.385V102.615C91 100.066 88.926 98 86.3676 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.357 98H102.643C100.079 98 98 100.066 98 102.615V105.385C98 107.934 100.079 110 102.643 110H145.357C147.921 110 150 107.934 150 105.385V102.615C150 100.066 147.921 98 145.357 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.395 98H162.605C160.062 98 158 100.066 158 102.615V105.385C158 107.934 160.062 110 162.605 110H223.395C225.938 110 228 107.934 228 105.385V102.615C228 100.066 225.938 98 223.395 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.375 98H239.625C237.071 98 235 100.066 235 102.615V105.385C235 107.934 237.071 110 239.625 110H267.375C269.929 110 272 107.934 272 105.385V102.615C272 100.066 269.929 98 267.375 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4 98H284.6C282.059 98 280 100.066 280 102.615V105.385C280 107.934 282.059 110 284.6 110H321.4C323.941 110 326 107.934 326 105.385V102.615C326 100.066 323.941 98 321.4 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.319 98H337.681C335.096 98 333 100.066 333 102.615V105.385C333 107.934 335.096 110 337.681 110H372.319C374.904 110 377 107.934 377 105.385V102.615C377 100.066 374.904 98 372.319 98Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4167 119H32.5833C30.052 119 28 121.066 28 123.615V126.385C28 128.934 30.052 131 32.5833 131H67.4167C69.948 131 72 128.934 72 126.385V123.615C72 121.066 69.948 119 67.4167 119Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.417 119H84.5833C82.052 119 80 121.066 80 123.615V126.385C80 128.934 82.052 131 84.5833 131H141.417C143.948 131 146 128.934 146 126.385V123.615C146 121.066 143.948 119 141.417 119Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.352 119H158.648C156.081 119 154 121.066 154 123.615V126.385C154 128.934 156.081 131 158.648 131H215.352C217.919 131 220 128.934 220 126.385V123.615C220 121.066 217.919 119 215.352 119Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4167 225H32.5833C30.052 225 28 227.066 28 229.615V232.385C28 234.934 30.052 237 32.5833 237H67.4167C69.948 237 72 234.934 72 232.385V229.615C72 227.066 69.948 225 67.4167 225Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.417 225H84.5833C82.052 225 80 227.066 80 229.615V232.385C80 234.934 82.052 237 84.5833 237H141.417C143.948 237 146 234.934 146 232.385V229.615C146 227.066 143.948 225 141.417 225Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.352 225H158.648C156.081 225 154 227.066 154 229.615V232.385C154 234.934 156.081 237 158.648 237H215.352C217.919 237 220 234.934 220 232.385V229.615C220 227.066 217.919 225 215.352 225Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 140H32.6667C30.0893 140 28 142.066 28 144.615V147.385C28 149.934 30.0893 152 32.6667 152H37.3333C39.9107 152 42 149.934 42 147.385V144.615C42 142.066 39.9107 140 37.3333 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38 140H53.6203C51.0686 140 49 142.066 49 144.615V147.385C49 149.934 51.0686 152 53.6203 152H117.38C119.931 152 122 149.934 122 147.385V144.615C122 142.066 119.931 140 117.38 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.417 140H134.583C132.052 140 130 142.066 130 144.615V147.385C130 149.934 132.052 152 134.583 152H147.417C149.948 152 152 149.934 152 147.385V144.615C152 142.066 149.948 140 147.417 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.312 140H163.688C161.099 140 159 142.066 159 144.615V147.385C159 149.934 161.099 152 163.688 152H214.312C216.901 152 219 149.934 219 147.385V144.615C219 142.066 216.901 140 214.312 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.349 140H230.651C228.082 140 226 142.066 226 144.615V147.385C226 149.934 228.082 152 230.651 152H261.349C263.918 152 266 149.934 266 147.385V144.615C266 142.066 263.918 140 261.349 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.375 140H277.625C275.071 140 273 142.066 273 144.615V147.385C273 149.934 275.071 152 277.625 152H342.375C344.929 152 347 149.934 347 147.385V144.615C347 142.066 344.929 140 342.375 140Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3571 161H32.6429C30.0787 161 28 163.066 28 165.615V168.385C28 170.934 30.0787 173 32.6429 173H62.3571C64.9213 173 67 170.934 67 168.385V165.615C67 163.066 64.9213 161 62.3571 161Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3571 183H32.6429C30.0787 183 28 185.066 28 187.615V190.385C28 192.934 30.0787 195 32.6429 195H75.3571C77.9213 195 80 192.934 80 190.385V187.615C80 185.066 77.9213 183 75.3571 183Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.329 183H91.6711C89.0913 183 87 185.066 87 187.615V190.385C87 192.934 89.0913 195 91.6711 195H153.329C155.909 195 158 192.934 158 190.385V187.615C158 185.066 155.909 183 153.329 183Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.435 183H169.565C167.044 183 165 185.066 165 187.615V190.385C165 192.934 167.044 195 169.565 195H181.435C183.956 195 186 192.934 186 190.385V187.615C186 185.066 183.956 183 181.435 183Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3571 204H32.6429C30.0787 204 28 206.066 28 208.615V211.385C28 213.934 30.0787 216 32.6429 216H88.3571C90.9213 216 93 213.934 93 211.385V208.615C93 206.066 90.9213 204 88.3571 204Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.395 204H104.605C102.062 204 100 206.066 100 208.615V211.385C100 213.934 102.062 216 104.605 216H130.395C132.938 216 135 213.934 135 211.385V208.615C135 206.066 132.938 204 130.395 204Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.391 204H147.609C145.064 204 143 206.066 143 208.615V211.385C143 213.934 145.064 216 147.609 216H197.391C199.936 216 202 213.934 202 211.385V208.615C202 206.066 199.936 204 197.391 204Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.312 204H213.688C211.099 204 209 206.066 209 208.615V211.385C209 213.934 211.099 216 213.688 216H234.312C236.901 216 239 213.934 239 211.385V208.615C239 206.066 236.901 204 234.312 204Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.278 204H250.722C248.114 204 246 206.066 246 208.615V211.385C246 213.934 248.114 216 250.722 216H275.278C277.886 216 280 213.934 280 211.385V208.615C280 206.066 277.886 204 275.278 204Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.373 204H291.627C289.072 204 287 206.066 287 208.615V211.385C287 213.934 289.072 216 291.627 216H344.373C346.928 216 349 213.934 349 211.385V208.615C349 206.066 346.928 204 344.373 204Z",
    fill: "white",
    fillOpacity: 0.05
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8255,
    cy: 29.0123,
    r: 4.14461,
    fill: "#FC165B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.0882,
    cy: 29.0123,
    r: 4.14461,
    fill: "#FCA016"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.351,
    cy: 29.0123,
    r: 4.14461,
    fill: "#16FCA9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_59_619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 325,
    width: 123,
    height: 105,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.75 360.5H55.25C53.317 360.5 51.75 362.067 51.75 364V392C51.75 393.933 53.317 395.5 55.25 395.5H72.75C74.683 395.5 76.25 393.933 76.25 392V364C76.25 362.067 74.683 360.5 72.75 360.5Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 388.5H64.0175",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_59_619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 325,
    width: 123,
    height: 105,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 362.25H188C186.067 362.25 184.5 363.817 184.5 365.75V383.25C184.5 385.183 186.067 386.75 188 386.75H216C217.933 386.75 219.5 385.183 219.5 383.25V365.75C219.5 363.817 217.933 362.25 216 362.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 393.75H209",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 386.75V393.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_59_619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 325,
    width: 123,
    height: 105,
    rx: 10,
    fill: "white",
    fillOpacity: 0.05
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 395.5C349.665 395.5 357.5 387.665 357.5 378C357.5 368.335 349.665 360.5 340 360.5C330.335 360.5 322.5 368.335 322.5 378C322.5 387.665 330.335 395.5 340 395.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.5 378H357.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 360.5C344.377 365.292 346.865 371.511 347 378C346.865 384.489 344.377 390.708 340 395.5C335.623 390.708 333.135 384.489 333 378C333.135 371.511 335.623 365.292 340 360.5V360.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M196.5 267C196.5 265.328 197.828 264 199.5 264V261C196.172 261 193.5 263.672 193.5 267H196.5ZM199.5 264C201.172 264 202.5 265.328 202.5 267H205.5C205.5 263.672 202.828 261 199.5 261V264ZM202.5 267C202.5 268.672 201.172 270 199.5 270V273C202.828 273 205.5 270.328 205.5 267H202.5ZM199.5 270C197.828 270 196.5 268.672 196.5 267H193.5C193.5 270.328 196.172 273 199.5 273V270ZM198 271.5V296H201V271.5H198ZM198 296V325H201V296H198Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 262.5C197 262.5 195 264.5 195 267C195 269.5 197 271.5 199.5 271.5C202 271.5 204 269.5 204 267C204 264.5 202 262.5 199.5 262.5Z",
    fill: "#6016FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 267C196.5 265.328 197.828 264 199.5 264V261C196.172 261 193.5 263.672 193.5 267H196.5ZM199.5 264C201.172 264 202.5 265.328 202.5 267H205.5C205.5 263.672 202.828 261 199.5 261V264ZM202.5 267C202.5 268.672 201.172 270 199.5 270V273C202.828 273 205.5 270.328 205.5 267H202.5ZM199.5 270C197.828 270 196.5 268.672 196.5 267H193.5C193.5 270.328 196.172 273 199.5 273V270ZM198 271.5V281H201V271.5H198ZM179.5 299.5H74V302.5H179.5V299.5ZM62.5 311V325H65.5V311H62.5ZM74 299.5C67.6487 299.5 62.5 304.649 62.5 311H65.5C65.5 306.306 69.3056 302.5 74 302.5V299.5ZM198 281C198 291.217 189.717 299.5 179.5 299.5V302.5C191.374 302.5 201 292.874 201 281H198Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M196.5 267C196.5 265.328 197.828 264 199.5 264V261C196.172 261 193.5 263.672 193.5 267H196.5ZM199.5 264C201.172 264 202.5 265.328 202.5 267H205.5C205.5 263.672 202.828 261 199.5 261V264ZM202.5 267C202.5 268.672 201.172 270 199.5 270V273C202.828 273 205.5 270.328 205.5 267H202.5ZM199.5 270C197.828 270 196.5 268.672 196.5 267H193.5C193.5 270.328 196.172 273 199.5 273V270ZM198 271.5V281H201V271.5H198ZM219.5 302.5H329.5V299.5H219.5V302.5ZM338 311V325H341V311H338ZM329.5 302.5C334.194 302.5 338 306.306 338 311H341C341 304.649 335.851 299.5 329.5 299.5V302.5ZM198 281C198 292.874 207.626 302.5 219.5 302.5V299.5C209.283 299.5 201 291.217 201 281H198Z",
    fill: "white",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_59_619",
    x: -74,
    y: -74,
    width: 547,
    height: 415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_59_619",
    x: -72,
    y: 251,
    width: 271,
    height: 253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_59_619",
    x: 66,
    y: 251,
    width: 271,
    height: 253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_59_619",
    x: 204,
    y: 251,
    width: 271,
    height: 253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 359,
    height: 191,
    fill: "white",
    transform: "translate(28 55)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailed);
export default __webpack_public_path__ + "static/media/detailed.67e62ef0adfce2eca6ed262c036c7fbd.svg";
export { ForwardRef as ReactComponent };